import { render } from "./CallbackThankYou.vue?vue&type=template&id=ebd98800&scoped=true&ts=true"
import script from "./CallbackThankYou.vue?vue&type=script&lang=ts"
export * from "./CallbackThankYou.vue?vue&type=script&lang=ts"

import "./CallbackThankYou.vue?vue&type=style&index=0&id=ebd98800&scoped=true&lang=css"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd98800"]])

export default __exports__